const OpportunityInfoTab = () => {
    return(
        <div>
            Hello World! This is the Opportunity Info Tab.
        </div>
    )
}
export default OpportunityInfoTab;